import { DataAttributeDefinitions } from 'scrivito'

import { pisaDocumentDataClass } from './Pisa/pisaDocumentDataClass'

const attributes: DataAttributeDefinitions = {}

export const Document = pisaDocumentDataClass(attributes)
